import React, { useState } from 'react'
import styled from 'styled-components'
import { compose } from 'redux'
import { firestoreConnect } from 'react-redux-firebase'
import { connect } from 'react-redux'
import { useTranslation } from 'react-i18next'

function QA(props) {
  const { t } = useTranslation('proposals')
  const [loading, setLoading] = useState(true)

  const handleIframeLoad = () => {
    setLoading(false)
  }

  return (
    <Container>
      {loading && <LoadingMessage>{t('Loading...')}</LoadingMessage>}
      <IframeContainer style={{ display: loading ? 'none' : 'block' }}>
        <iframe
          src="https://q-and-a-table.vercel.app/competitions/7"
          title="Embedded Q&A Page"
          width="100%"
          height="600px"
          style={{ border: 'none' }}
          onLoad={handleIframeLoad}
        />
      </IframeContainer>
    </Container>
  )
}

const mapStateToProps = state => {
  return {
    'sub-b-proposals': state.firestore.ordered['sub-b-proposals']
  }
}

export default compose(
  connect(mapStateToProps),
  firestoreConnect([
    { collection: 'sub-b-proposals', orderBy: ['createdAt', 'asc'] }
  ])
)(QA)

const Container = styled.div`
  /* padding: 32px; */
  flex: 1;
  user-select: text;
  background-color: #fff;
  position: relative;

  h3 {
    margin-bottom: 7px;
  }
`

const IframeContainer = styled.div`
  margin-top: 20px;
  width: 100%;
  height: 600px;
  overflow: hidden;
`

const LoadingMessage = styled.div`
  text-align: center;
  padding: 20px;
  font-size: 18px;
`
